
import { Component, Prop, Vue } from "vue-property-decorator";
import GiftListSlider from "./GiftListSlider.vue";

@Component({
	components: {
		GiftListSlider,
	},
})
export default class GiftListPanel extends Vue {
	// isLoggedUser = false;
	showClearPanelConfirm = false;
	hidingClearPanelConfirm = false;
	showingClearPanelConfirm = false;
	hoverGiftFinderBtn = false;
	// wishListUrl = "";
	@Prop() private giftList: string[];

	get isGiftFinderPage() {
		return this.$root.$data.isGiftFinderPage;
	}

	get giftListComputed() {
		return this.giftList;
	}

	get isLoggedUser() {
		return !!this.$root.$data.isLoggedUser;
	}

	get wishListUrl() {
		return (
			this.$root.$data.wishListUrl +
			(this.$root.$data.giftListId ? this.$root.$data.giftListId + "/" : "")
		);
	}

	created() {
		// this.isLoggedUser = !!this.$root.$data.isLoggedUser;
		// this.wishListUrl = this.$root.$data.wishListUrl;
	}

	toggleClearPanelConfirm() {
		this.showingClearPanelConfirm = !this.showClearPanelConfirm;
		this.hidingClearPanelConfirm = this.showClearPanelConfirm;
		setTimeout(() => {
			this.showClearPanelConfirm = !this.showClearPanelConfirm;
			this.showingClearPanelConfirm = false;
			this.hidingClearPanelConfirm = false;
		}, 600);
	}

	scrollToGiftFinder() {
		this.$bus.$emit("epoqScrollToGiftFinder");
	}

	closeGiftList() {
		this.$bus.$emit("epoqCloseGiftList");
	}

	clearGiftList() {
		this.$bus.$emit("epoqCloseGiftList");
		this.$bus.$emit("epoqClearGiftList");
	}

	sendCustomGotoGiftfinderEvent() {
		window.dataLayer.push({
			event: "shopEvent",
			eventCategory: "Geschenkefinder",
			eventAction: "Zum Geschenkefinder",
			eventLabel: "",
		});
	}

	sendCustomGotoWishlistEvent() {
		window.dataLayer.push({
			event: "shopEvent",
			eventCategory: "Geschenkefinder",
			eventAction: "Zur Merkliste",
			eventLabel: "",
		});
	}

	getGiftFinderUrl() {
		return this.$root.$data.giftFinderUrl;
	}
}
